const TITLE_WORDS = new Set([
  "대통령",
  "대표",
  "총리",
  "장관",
  "위원장",
  "의원",
  "시장",
  "지사",
  "사장",
  "회장",
  "후보",
  "대법관",
  "검사",
  "감독",
  "코치",
  "주교",
  "주장",
]);

const STOPWORDS = new Set([
  "관련",
  "오늘",
  "어제",
  "내일",
  "이번",
  "지난",
  "최근",
  "정부",
  "국회",
  "논란",
  "발언",
  "인터뷰",
  "이날",
  "당시",
  "때문",
  "경우",
  "대표",
  "대통령",
  "총리",
  "위원장",
  "의원",
  "시장",
  "지사",
  "사장",
  "회장",
  "후보",
  "검사",
  "참석",
  "예정",
  "계획",
  "발표",
  "발표한",
  "밝혀",
  "밝혔다",
  "제기",
  "제기된",
  "회의",
  "등",
  "그리고",
  "하지만",
  "주세요",
]);

const PARTICLE_REGEX =
  /(에서|에게서|으로써|으로서|이라고|라고|이라며|이라|였다|이었다|에게|께서|까지|부터|처럼|보다|으로|로|이며|하고|과의|와의|과|와|은|는|이|가|을|를|도|만|에|서)$/u;

const CLEAN_TEXT_REGEX = /[“”‘’"'(){}[\],.!?;:+]/g;

const HANGUL_OR_HAN_REGEX = /^[\u1100-\u11FF\u3130-\u318F\uAC00-\uD7A3\u4E00-\u9FFF]+$/u;

const HYPHEN_SEGMENT_MAP = {
  한: "한국",
  남: "대한민국",
  북: "북한",
  미: "미국",
  일: "일본",
  중: "중국",
  러: "러시아",
  영: "영국",
  독: "독일",
  프: "프랑스",
  호: "호주",
  캐: "캐나다",
  멕: "멕시코",
  싱: "싱가포르",
  싱가포르: "싱가포르",
  인: "인도",
  이: "이탈리아",
  스: "스페인",
  브: "브라질",
};

function stripParticles(token) {
  let stripped = token;
  let attempts = 0;
  while (attempts < 3 && PARTICLE_REGEX.test(stripped)) {
    stripped = stripped.replace(PARTICLE_REGEX, "");
    attempts += 1;
  }
  return stripped;
}

function isNumericToken(token) {
  return /^[0-9]+([.,]?[0-9]+)?(조원|억원|만원|%|년|월|일|kg|km|억|조|만)?$/u.test(token);
}

function isMostlyAlphabetic(token) {
  return /^[A-Za-z]{2,}$/u.test(token);
}

function isHangulOrHan(token) {
  return HANGUL_OR_HAN_REGEX.test(token);
}

function looksValidKeyword(token) {
  if (!token || typeof token !== "string") return false;
  if (STOPWORDS.has(token)) return false;
  if (token.length === 1 && !isNumericToken(token)) return false;
  if (/^\d+$/.test(token)) return false;
  if (/^[0-9]+년$/.test(token)) return false;
  if (token.length < 2 && !isNumericToken(token)) return false;
  if (/^[\u0021-\u0040]+$/u.test(token)) return false;

  return isHangulOrHan(token) || isNumericToken(token) || isMostlyAlphabetic(token);
}

function normalizeToken(token) {
  if (!token) return "";
  const cleaned = token.replace(CLEAN_TEXT_REGEX, " ").replace(/\s+/g, " ").trim();
  return stripParticles(cleaned);
}

function expandHyphenSegment(segment) {
  if (!segment) return "";
  const base = stripParticles(segment);
  if (!base) return "";
  if (HYPHEN_SEGMENT_MAP[base]) {
    return HYPHEN_SEGMENT_MAP[base];
  }
  return base;
}

function extractWikiKeywords(text) {
  if (!text || typeof text !== "string") return [];

  const normalized = text
    .replace(/[·]/g, " ")
    .replace(CLEAN_TEXT_REGEX, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!normalized) return [];

  const rawTokens = normalized.split(" ").filter(Boolean);
  const result = [];

  for (let i = 0; i < rawTokens.length; i += 1) {
    const currentRaw = rawTokens[i];
    const next = rawTokens[i + 1];
    const afterNext = rawTokens[i + 2];
    if (!currentRaw) continue;

    if (currentRaw.includes("-")) {
      const segments = currentRaw.split(/-+/).map((seg) => expandHyphenSegment(normalizeToken(seg)));
      segments
        .map((seg) => seg && seg.trim())
        .filter(Boolean)
        .forEach((seg) => {
          if (looksValidKeyword(seg)) {
            result.push(seg);
          }
        });
      continue;
    }

    if (currentRaw === "전") {
      continue;
    }

    if (next === "전" && TITLE_WORDS.has(afterNext)) {
      const baseToken = normalizeToken(currentRaw);
      if (looksValidKeyword(baseToken)) {
        result.push(baseToken);
      }
      i += 2;
      continue;
    }

    if (next && TITLE_WORDS.has(next)) {
      const baseToken = normalizeToken(currentRaw);
      if (
        baseToken.length === 1 ||
        /^[\u4E00-\u9FFF]$/u.test(baseToken) ||
        /^[A-Z]$/i.test(baseToken)
      ) {
        result.push(`${baseToken} ${next}`);
        i += 1;
        continue;
      }
    }

    if (TITLE_WORDS.has(currentRaw)) {
      continue;
    }

    let token = normalizeToken(currentRaw);
    if (token.length === 1 && HYPHEN_SEGMENT_MAP[token]) {
      token = HYPHEN_SEGMENT_MAP[token];
    }
    if (!looksValidKeyword(token)) {
      continue;
    }

    result.push(token);
  }

  return Array.from(new Set(result));
}

module.exports = {
  extractWikiKeywords,
  extractUniqueWords: extractWikiKeywords,
};
